import React from 'react';
import { useCart } from '../context/CartContext';

export default function Footer() {
  const { setCurrentPage } = useCart();
  const nav = (page) => { setCurrentPage(page); window.scrollTo({ top: 0 }); };
  const navPolicy = (slug) => { setCurrentPage(`policy:${slug}`); window.scrollTo({ top: 0 }); };

  return (
    <footer className="footer-premium">
      <div className="footer-premium-grid">
        {/* BRAND */}
        <div className="footer-brand-col">
          <div className="footer-premium-logo-row">
            <img src="/images/badge_color.webp" alt="Organic Slim Fit" className="footer-premium-logo-img" width="62" height="62" />
            <div className="footer-premium-brand-name">Organic Slim Fit</div>
          </div>
          <p className="footer-premium-desc">
            Rooted in nature, crafted for wellness. A herbal tea brand committed to pure, natural fat-loss
            support — one cup at a time. Trusted by 10,000+ happy customers across Pakistan.
          </p>
          <div className="footer-premium-social">
            <a href="https://www.instagram.com/organicslimfittt/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8"/>
                <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8"/>
                <circle cx="17.3" cy="6.7" r="1.15" fill="currentColor"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/organicslimfitt" target="_blank" rel="noreferrer" aria-label="Facebook">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 8.5h2.5V5.3c-.43-.06-1.9-.19-3.62-.19-3.58 0-6.03 2.25-6.03 6.38v2.99H4.5v3.6h3.35V22h3.7v-3.92h3.22l.51-3.6h-3.73v-2.62c0-1.04.29-1.76 1.75-1.76z" fill="currentColor"/>
              </svg>
            </a>
            <a href="https://wa.me/923111100340" target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <svg width="17" height="17" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.02 3C9.4 3 4 8.37 4 15c0 2.35.66 4.55 1.8 6.43L4 29l7.76-1.75A11.9 11.9 0 0 0 16.02 27C22.65 27 28 21.63 28 15S22.65 3 16.02 3zm0 21.6c-1.98 0-3.83-.55-5.4-1.5l-.39-.23-4.6 1.04 1.02-4.48-.25-.4A9.55 9.55 0 0 1 5.4 15c0-5.86 4.77-10.6 10.62-10.6S26.6 9.14 26.6 15 21.87 24.6 16.02 24.6zm5.86-7.94c-.32-.16-1.9-.94-2.2-1.04-.3-.1-.5-.16-.72.16-.21.32-.83 1.04-1.02 1.25-.19.2-.37.23-.7.08-.32-.16-1.35-.5-2.57-1.6-.95-.85-1.6-1.9-1.78-2.22-.19-.32-.02-.5.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.1-.2.05-.4-.03-.55-.08-.16-.72-1.74-1-2.38-.26-.63-.53-.54-.72-.55-.19-.01-.4-.01-.6-.01-.21 0-.55.08-.83.4-.29.32-1.1 1.07-1.1 2.6s1.12 3.02 1.28 3.23c.16.2 2.2 3.37 5.34 4.72.75.32 1.33.51 1.78.66.75.24 1.43.2 1.97.13.6-.09 1.9-.78 2.17-1.53.27-.75.27-1.4.19-1.53-.08-.13-.29-.21-.6-.37z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-premium-col">
          <h4>Quick Links</h4>
          <button className="footer-link-btn" onClick={() => nav('home')}>Home</button>
          <button className="footer-link-btn" onClick={() => nav('reviews')}>Reviews</button>
          <button className="footer-link-btn" onClick={() => nav('blog')}>Blog</button>
          <button className="footer-link-btn" onClick={() => nav('videos')}>Videos</button>
          <button className="footer-link-btn" onClick={() => nav('contact')}>Contact</button>
        </div>

        {/* SUPPORT */}
        <div className="footer-premium-col">
          <h4>Support</h4>
          <button className="footer-link-btn" onClick={() => navPolicy('terms-conditions')}>Terms &amp; Conditions</button>
          <button className="footer-link-btn" onClick={() => navPolicy('delivery-policy')}>Shipping Policy</button>
          <button className="footer-link-btn" onClick={() => navPolicy('refund-policy')}>Refund Policy</button>
          <button className="footer-link-btn" onClick={() => navPolicy('return-exchange-policy')}>Return &amp; Exchange Policy</button>
          <button className="footer-link-btn" onClick={() => navPolicy('cancellation-policy')}>Cancellation Policy</button>
          <button className="footer-link-btn" onClick={() => navPolicy('privacy-policy')}>Privacy Policy</button>
        </div>

        {/* CONTACT */}
        <div className="footer-premium-col">
          <h4>Contact</h4>
          <div className="footer-premium-contact-item">
            <span className="icon">📧</span>
            <a href="mailto:contact@organicslimfit.com" style={{ marginBottom: 0 }}>contact@organicslimfit.com</a>
          </div>
          <div className="footer-premium-contact-item">
            <span className="icon">💬</span>
            <a href="https://wa.me/923111100340" target="_blank" rel="noreferrer" style={{ marginBottom: 0 }}>WhatsApp Order</a>
          </div>
          <div className="footer-premium-contact-item">
            <span className="icon">📞</span>
            <span>+92 311 11 00 340</span>
          </div>
          <div className="footer-premium-contact-item">
            <span className="icon">📍</span>
            <span>Lahore, Pakistan</span>
          </div>
        </div>
      </div>

      <div className="footer-premium-bottom">
        <span>© 2026 Organic Slim Fit — Rooted in Nature. Crafted for Wellness.</span>
        <span>All rights reserved.</span>
      </div>
    </footer>
  );
}
